// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cKKt","brands":"styles_brands__3il9c","wideBrands":"styles_wideBrands__3hRqC","brandsMobile":"styles_brandsMobile__2NOow"};